import { createSelector } from 'reselect';
import { profileAPI } from '@/api/careClient';
const initialState = {
    state: null,
    contract: '',
    marketingChannelList: [],
};
var ACTION_TYPES;
(function (ACTION_TYPES) {
    ACTION_TYPES["CARE_CLIENT_VISITOR_PROFILE_INIT"] = "careClientVisitorProfile/init";
})(ACTION_TYPES || (ACTION_TYPES = {}));
export default function careClientVisitorProfileReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.CARE_CLIENT_VISITOR_PROFILE_INIT: {
            return { ...state, ...action.payload };
        }
        default:
            return state;
    }
}
// actions
export const careClientVisitorProfileInit = (payload) => ({
    type: ACTION_TYPES.CARE_CLIENT_VISITOR_PROFILE_INIT,
    payload,
});
// thunks
export const fetchCareClientVisitorProfile = ({ _id, setApiProcessingPool, setApiDonePool, customParams, }) => async (dispatch) => {
    const res = await profileAPI.Get({
        _id,
        ...(customParams && customParams),
    }, setApiProcessingPool, setApiDonePool);
    if (res.success && res.data) {
        const profile = res.data;
        dispatch(careClientVisitorProfileInit(profile));
        return { isSuccess: true, errorCode: '' };
    }
    return { isSuccess: false, errorCode: res.errorCode };
};
// selectors
export const selectCareClientVisitorProfile = createSelector((state) => state.careClientVisitorProfile, (careClientVisitorProfile) => careClientVisitorProfile);
